export abstract class CommonConstants {
    //RGStatus
    public static readonly RG_STATUS_GREEN: string = 'green';
    public static readonly STATUS_SUSPENDED: string = 'suspended';
    public static readonly STATUS_CLOSED: string = 'CLOSED';
    public static readonly STATUS_SUSPICIOUS: string = 'SUSPICIOUS';
    public static readonly STATUS_FRAUD: string = 'FRAUD';
    public static readonly STATUS_RGCLOSED: string = 'RGCLOSED';
    public static readonly STATUS_CLOSEDINACTIVE: string = 'CLOSEDINACTIVE';
    public static readonly STATUS_PERMENANTLYCLOSED: string = 'PERMENANTLYCLOSED';
    public static readonly STATUS_BLOCKED: string = 'BLOCKED';
    public static readonly STATUS_ONCOOL_OFF: string = 'OnCool-Off';
    public static readonly CLAIM_RGS: string = 'rgs';
    public static readonly CLAIM_ECC: string = 'ecc';
    public static readonly CLAIM_BS: string = 'bs';
    public static readonly CLAIM_JURISDICTION: string = 'jurisdiction';
    public static readonly CLAIM_TIERCODE: string = 'tiercode';
    // dsesign systems constants start
    public static readonly Default: string = 'default';
    public static readonly MoreInfo: string = 'moreInfo';
    public static readonly ConfirmDialogCtas: string = 'confirmDialogCtas';
    public static readonly CommonPopupV2: string = 'commonPopupV2';
    public static readonly RewardPrize: string = 'rewardPrize';
    public static readonly DetailPagePlayNow: string = 'detailPagePlayNow';
    public static readonly EdsMultiRewardPopup: string = 'edsMultiRewardPopup';
    public static readonly viewAll: string = 'viewAll';
    public static readonly checkOtherPromotions: string = 'checkOtherPromotions';
    public static readonly SubNav: string = 'subnav';
    public static readonly filterDivider: string = 'filter';
    public static readonly CoinEconomy: string = 'coinEconomy';
    public static readonly Tnc: string = 'tnc';
    public static readonly CoinEconomyMyReward: string = 'ce-my-reward';

    // dsesign systems constants end
}
